import { camelize } from '@ridi/object-case-converter';
import classNames from 'classnames';
import { Children, Component, Fragment, cloneElement, createElement, isValidElement } from 'react';
import { Icon } from '@ridi/rsg';
import { kebabCase, mapKeys } from 'lodash-es';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





























function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var CircleBadgeType;
(function (CircleBadgeType) {
    CircleBadgeType["WaitFree"] = "waitFree";
    CircleBadgeType["Rental"] = "rental";
    CircleBadgeType["Freebook"] = "freebook";
    CircleBadgeType["Discount"] = "discount";
})(CircleBadgeType || (CircleBadgeType = {}));
var circleBadge = (function (data) { return function (props) {
    var className = props.className;
    var Placeholder = data.setPlaceholder(false, !data.type);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    var computedClassName = classNames(data.className, data.className + "-type-" + data.type, (_a = {}, _a[data.className + "-effect-glow"] = data.type === CircleBadgeType.Freebook && data.emphasis, _a[data.className + "-small"] = props.thumbnailSize < 80, _a), className);
    return (createElement("div", { className: classNames(computedClassName) },
        createElement("div", { className: data.className + "_TextWrapper" },
            data.type === CircleBadgeType.WaitFree && (createElement(Fragment, null,
                createElement(Icon, { name: "timer_2", className: data.className + "_WaitFree_Icon" }),
                createElement("span", { className: "invisible" }, "\uAE30\uB2E4\uB9AC\uBA74 \uBB34\uB8CC \uB3C4\uC11C"))),
            data.type === CircleBadgeType.Rental && (createElement(Fragment, null,
                createElement("span", { className: data.className + "_Label " + data.className + "_Label-rental" }, "\uB300\uC5EC"),
                createElement("span", { className: "invisible" }, "\uAC00\uB2A5 \uB3C4\uC11C"))),
            data.type === CircleBadgeType.Freebook && (createElement(Fragment, null,
                createElement("span", { className: data.className + "_Label " + data.className + "_Label-freebookCount museoSans" }, data.count),
                data.unit,
                createElement("br", null),
                "\uBB34\uB8CC")),
            data.type === CircleBadgeType.Discount && (createElement(Fragment, null,
                createElement("span", { className: data.className + "_Label " + data.className + "_Label-discountRate museoSans" }, data.rate),
                "%",
                createElement("span", { className: "invisible" }, "\uD560\uC778"))))));
    var _a;
}; });

function getWaitFreeBadgeProps(dto) {
    var isWaitFree = dto.property.isWaitFree;
    return isWaitFree ? {
        type: CircleBadgeType.WaitFree,
    } : undefined;
}
function getRentalBadgeProps(dto) {
    var _a = dto.categories[0], genre = _a.genre, subGenre = _a.subGenre;
    var isRental = dto.property.isRental;
    var isBlSeparateVolume = (genre === 'bl' || subGenre === 'bl') && !(dto.series && dto.series.property.isSerial);
    var isRentalBadgePropsEnableGenre = ['general', 'romance'].includes(genre) || isBlSeparateVolume;
    return isRental && isRentalBadgePropsEnableGenre ? {
        type: CircleBadgeType.Rental,
    } : undefined;
}
function getDiscountBadgeProps(dto) {
    var isSeries = Boolean(dto.series && dto.series.property);
    var discountRate = (function () {
        var maxDiscountRate = 0;
        try {
            var priceInfo = dto.priceInfo, _a = dto.series, _b = (_a === void 0 ? {} : _a).priceInfo, seriesPriceInfo = _b === void 0 ? {} : _b;
            var _c = (priceInfo.buy || {}).discountPercentage, buyDiscount = _c === void 0 ? 0 : _c;
            var _d = (priceInfo.rent || {}).discountPercentage, rentDiscount = _d === void 0 ? 0 : _d;
            maxDiscountRate = Math.max(buyDiscount, rentDiscount);
            if (isSeries) {
                var _e = (seriesPriceInfo.buy || {}).discountPercentage, seriesBuyDiscount = _e === void 0 ? 0 : _e;
                var _f = (seriesPriceInfo.rent || {}).discountPercentage, seriesRentDiscount = _f === void 0 ? 0 : _f;
                maxDiscountRate = Math.max(maxDiscountRate, seriesBuyDiscount, seriesRentDiscount);
            }
            return maxDiscountRate;
        }
        catch (_g) {
            return maxDiscountRate;
        }
    })();
    var inDiscountBadgePropsRange = (discountRate < 100) && (discountRate >= 10);
    var ignoreDiscountBadgeProps = isSeries && dto.series.property.freeBookCount >= 4;
    return inDiscountBadgePropsRange && !ignoreDiscountBadgeProps && {
        type: CircleBadgeType.Discount,
        rate: discountRate,
    };
}
function getFreebookBadgeProps(dto) {
    try {
        var _a = dto.series && dto.series.property || {}, _b = _a.freeBookCount, freeBookCount = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? '' : _c;
        return freeBookCount && {
            type: CircleBadgeType.Freebook,
            count: freeBookCount,
            unit: unit,
            emphasis: freeBookCount >= 40,
        };
    }
    catch (_d) {
        return null;
    }
}
function getCircleBadge(dto) {
    var waitFreeBadgeProps = getWaitFreeBadgeProps(dto);
    var rentalBadgeProps = getRentalBadgeProps(dto);
    var discountBadgeProps = getDiscountBadgeProps(dto);
    var freebookBadgeProps = getFreebookBadgeProps(dto);
    return waitFreeBadgeProps || rentalBadgeProps || discountBadgeProps || freebookBadgeProps;
}

function trim(strings) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    return strings.reduce(function (prev, cur, i) { return prev + cur + (values[i] || ''); }, '').trim();
}
function dto2props (dto) {
    var thumbnailProps = {
        wrapper: {
            link: "/v2/Detail?id=" + dto.id,
        },
        coverImage: {
            title: dto.title && dto.title.main,
            thumbnail: dto.thumbnail,
        },
        adultOnlyBadge: {
            isAdultOnly: dto.property && dto.property.isAdultOnly,
        },
        circleBadge: getCircleBadge(dto),
        hdBadge: {
            isComicHD: dto.file && dto.file.isComicHd,
        },
        setBooklet: dto.setbook,
    };
    var metadataProps = {
        authors: dto.authors,
        bookTypeBadge: {
            isComic: dto.property && dto.property.isComic,
            isNovel: dto.property && dto.property.isNovel,
        },
        description: {
            description: dto.description,
        },
        price: {
            book: dto.priceInfo,
            series: dto.series && dto.series.priceInfo,
        },
        publisher: dto.publisher && {
            name: dto.publisher.name,
            link: "/search?q=\uCD9C\uD310\uC0AC:" + dto.publisher.name,
        },
        seriesCount: dto.series && dto.series.property,
        somedealBadge: {
            isSomedeal: dto.property && dto.property.isSomedeal,
        },
        subTitle: {
            subTitle: dto.title && dto.title.sub,
        },
        title: {
            title: (function () {
                var _a = dto.title || {}, prefix = _a.prefix, title = _a.main;
                var seriesTitle = (dto.series && dto.series.property || {}).title;
                return trim(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", " ", ""], ["", " ", ""])), prefix, seriesTitle || title);
            })(),
            link: "/v2/Detail?id=" + dto.id,
        },
    };
    return { thumbnailProps: thumbnailProps, metadataProps: metadataProps };
}
var templateObject_1;

var Role;
(function (Role) {
    Role["Author"] = "author";
    Role["StoryWriter"] = "storyWriter";
    Role["Illustrator"] = "illustrator";
    Role["Translator"] = "translator";
    Role["Photo"] = "photo";
    Role["BiblioIntro"] = "biblioIntro";
    Role["Commentator"] = "commentator";
    Role["Editor"] = "editor";
    Role["OrigAuthor"] = "origAuthor";
    Role["OrigIllustrator"] = "origIllustrator";
    Role["Planner"] = "planner";
    Role["Supervisor"] = "supervisor";
    Role["Performer"] = "performer";
    Role["Compiler"] = "compiler";
})(Role || (Role = {}));
var Author = function (_a) {
    var id = _a.id, name = _a.name, className = _a.className;
    var authorLink = id ? "/author/" + id : "/search/?q=" + name;
    return createElement("a", { href: authorLink, className: className }, name);
};
var authors = (function (data) { return function (props) {
    var MAX_DISPLAY_COUNT = 2;
    var simple = props.simple, className = props.className, required = props.required;
    var _a = (function () {
        var priorities;
        if (data[Role.Author]) {
            priorities = [Role.Author, Role.Illustrator];
        }
        else if (data[Role.OrigAuthor]) {
            priorities = [Role.Illustrator, Role.OrigAuthor];
        }
        else {
            priorities = [
                Role.StoryWriter,
                Role.Illustrator,
                Role.Editor,
                Role.Photo,
                Role.Planner,
                Role.Commentator,
                Role.BiblioIntro,
            ];
        }
        var authors = priorities.flatMap(function (role) { return data[role] || []; });
        var count = authors.length;
        return {
            orderedAuthors: authors.splice(0, MAX_DISPLAY_COUNT),
            remainingAuthorCount: count - MAX_DISPLAY_COUNT,
            count: count,
        };
    })(), orderedAuthors = _a.orderedAuthors, remainingAuthorCount = _a.remainingAuthorCount, count = _a.count;
    var Placeholder = data.setPlaceholder(props.required, !count);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    return (createElement("div", { className: classNames(data.className, className) },
        orderedAuthors.map(function (author, index) { return (createElement(Fragment, { key: author.id || author.name },
            index > 0 && ', ',
            createElement(Author, __assign({ className: data.className + "_Item" }, author)))); }),
        remainingAuthorCount > 0 && (createElement("span", { className: data.className + "_Item" },
            "\uC678 ",
            remainingAuthorCount,
            "\uBA85"))));
}; });

var NOVEL = { type: 'novel', label: '소설' };
var COMIC = { type: 'comic', label: '만화' };
var bookTypeBadge = (function (data) { return function (props) {
    var isNovel = data.isNovel, isComic = data.isComic;
    var className = props.className;
    var _a = isNovel ? NOVEL : isComic ? COMIC : { type: false, label: '' }, type = _a.type, label = _a.label;
    var Placeholder = data.setPlaceholder(false, !type);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    return (createElement("div", { className: classNames(data.className, data.className + "-type-" + type, className) }, label));
}; });

var description = (function (data) { return function (props) {
    var className = props.className;
    var Placeholder = data.setPlaceholder(props.required, !data.description);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    var description = data.description.replace(/<[^>]+>/gi, '');
    var html = description.length > 160 ? description.slice(0, 160) + "..." : description;
    return (createElement("p", { className: classNames(data.className, className), dangerouslySetInnerHTML: { __html: html } }));
}; });

var currency = function (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var PriceEnum;
(function (PriceEnum) {
    PriceEnum["Buy"] = "buy";
    PriceEnum["Rent"] = "rent";
    PriceEnum["Cashback"] = "cashback";
    PriceEnum["Flatrate"] = "flatrate";
    PriceEnum["Pointback"] = "pointback";
    PriceEnum["Paper"] = "paper";
})(PriceEnum || (PriceEnum = {}));
var SeriesPriceEnum;
(function (SeriesPriceEnum) {
    SeriesPriceEnum["Buy"] = "buy";
    SeriesPriceEnum["Rent"] = "rent";
})(SeriesPriceEnum || (SeriesPriceEnum = {}));
var Cell = function (props) {
    var className = props.prefixClassName;
    if (!props.price && props.isSeries) {
        return null;
    }
    var minDiscountPercentageForRender = !props.isSeries ? 10 : 0;
    return (createElement("li", { className: className + "_Cell" },
        createElement("span", { className: className + "_Label" }, props.label),
        createElement("span", { className: className + "_CurrentPrice museoSans" }, props.price === 0 ? '무료' : currency(props.price) + "\uC6D0"),
        props.price > 0 && !props.hideDiscountRate && props.discountPercentage > 0 && (createElement(Fragment, null,
            props.discountPercentage >= minDiscountPercentageForRender && (createElement("span", { className: className + "_DiscountPercentage museoSans" }, props.discountPercentage + "%",
                createElement(Icon, { name: "arrow_10_down", className: className + "_DiscountPercentage_Icon" }))),
            props.isSeries && (createElement("del", { className: className + "_RegularPrice museoSans" }, currency(props.regularPrice) + "\uC6D0"))))));
};
var price = (function (data) { return function (props) {
    var className = props.className, hideSeries = props.hideSeries;
    var Placeholder = data.setPlaceholder(props.required);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    return (createElement("div", { className: classNames(data.className, className) },
        !!data.book.rent && (createElement("ul", { className: data.className + "_Row" },
            createElement(Cell, __assign({ label: "\uB300\uC5EC", prefixClassName: data.className, hideDiscountRate: !!data.series }, data.book.rent)),
            data.series && !hideSeries && createElement(Cell, __assign({ label: "\uC804\uAD8C \uB300\uC5EC", prefixClassName: data.className, isSeries: true }, data.series.rent)))),
        !!data.book.buy && (createElement("ul", { className: data.className + "_Row" },
            createElement(Cell, __assign({ label: "\uAD6C\uB9E4", prefixClassName: data.className, hideDiscountRate: !!data.series }, data.book.buy)),
            data.series && !hideSeries && createElement(Cell, __assign({ label: "\uC804\uAD8C \uAD6C\uB9E4", prefixClassName: data.className, isSeries: true }, data.series.buy))))));
}; });

var publisher = (function (data) { return function (props) {
    var className = props.className;
    var Placeholder = data.setPlaceholder(props.required, !data.name);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    return (createElement("div", { className: classNames(data.className, className) },
        createElement("a", { href: data.link }, data.name)));
}; });

var seriesCount = (function (data) { return function (props) {
    var className = props.className;
    var Placeholder = data.setPlaceholder(props.required, !data.totalBookCount);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    return (createElement("div", { className: classNames(data.className, className) },
        "\uCD1D ",
        data.totalBookCount,
        data.unit,
        data.isCompleted && createElement("span", { className: data.className + "_Complete" }, "\uC644\uACB0")));
}; });

var someDealBadge = (function (data) { return function (props) {
    var isSomedeal = data.isSomedeal;
    var className = props.className;
    var Placeholder = data.setPlaceholder(false, !isSomedeal);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    return (createElement("div", { className: classNames(data.className, data.className + "-type-somedeal", className) }, "\uC378\uB51C\uB3C4\uC11C"));
}; });

var subTitle = (function (data) { return function (props) {
    var className = props.className;
    var Placeholder = data.setPlaceholder(props.required, !data.subTitle);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    return (createElement("p", { className: classNames(data.className, className) }, data.subTitle));
}; });

var handleDataset = (function (dataset) {
    return mapKeys(dataset, function (value, key) { return "data-" + kebabCase(key); });
});

var title = (function (data) { return function (props) {
    var className = props.className, dataset = props.dataset;
    var Placeholder = data.setPlaceholder(props.required, !data.title);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    return props.link !== 'unused' ? (createElement("a", __assign({ href: data.link, className: classNames(data.className, className) }, handleDataset(dataset)), data.title)) : (createElement("p", { className: "RSGBookMetadata_Title" }, data.title));
}; });

var wrapper = (function (data) { return function (props) {
    return (createElement("div", { className: classNames(data.className, props.className) }, props.children));
}; });

function withDisplayName(name, Component$$1) {
    Component$$1.displayName = "Metadata." + name;
    return Component$$1;
}
var default_1 = (function () {
    function default_1(state, setPlaceholder) {
        this.state = state;
        this.setPlaceholder = setPlaceholder;
        this.wrapper = withDisplayName('wrapper', wrapper({
            className: 'RSGBookMetadata',
        }));
        this.title = withDisplayName('title', title(__assign({ className: 'RSGBookMetadata_Title', setPlaceholder: this.setPlaceholder }, this.state.metadataProps.title)));
        this.subTitle = withDisplayName('subTitle', subTitle(__assign({ className: 'RSGBookMetadata_SubTitle', setPlaceholder: this.setPlaceholder }, this.state.metadataProps.subTitle)));
        this.authors = withDisplayName('authors', authors(__assign({ className: 'RSGBookMetadata_Authors', setPlaceholder: this.setPlaceholder }, this.state.metadataProps.authors)));
        this.seriesCount = withDisplayName('seriesCount', seriesCount(__assign({ className: 'RSGBookMetadata_SeriesCount', setPlaceholder: this.setPlaceholder }, this.state.metadataProps.seriesCount)));
        this.publisher = withDisplayName('publisher', publisher(__assign({ className: 'RSGBookMetadata_Publisher', setPlaceholder: this.setPlaceholder }, this.state.metadataProps.publisher)));
        this.description = withDisplayName('description', description(__assign({ className: 'RSGBookMetadata_Description', setPlaceholder: this.setPlaceholder }, this.state.metadataProps.description)));
        this.price = withDisplayName('price', price(__assign({ className: 'RSGBookMetadata_Price', setPlaceholder: this.setPlaceholder }, this.state.metadataProps.price)));
        this.bookTypeBadge = withDisplayName('bookTypeBadge', bookTypeBadge(__assign({ className: 'RSGBookMetadata_Badge', setPlaceholder: this.setPlaceholder }, this.state.metadataProps.bookTypeBadge)));
        this.someDealBadge = withDisplayName('someDealBadge', someDealBadge(__assign({ className: 'RSGBookMetadata_Badge', setPlaceholder: this.setPlaceholder }, this.state.metadataProps.somedealBadge)));
    }
    return default_1;
}());

var adultOnlyBadge = (function (data) { return function (props) {
    var className = props.className;
    var Placeholder = data.setPlaceholder(false, !data.isAdultOnly);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    var computedClassName = classNames(data.className, (_a = {}, _a[data.className + "-small"] = props.thumbnailSize < 80, _a), className);
    return (createElement("span", { className: computedClassName },
        createElement("span", { className: "invisible" }, "19\uC138 \uBBF8\uB9CC \uAD6C\uB3C5\uBD88\uAC00")));
    var _a;
}; });

var coverImage = (function (data) { return function (props) {
    var className = props.className, _a = props.size, size = _a === void 0 ? 'large' : _a;
    var imageUrl = data.thumbnail && data.thumbnail[size];
    var Placeholder = data.setPlaceholder(props.required, !imageUrl);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    return createElement(Fragment, null,
        createElement("img", { className: classNames(data.className, className), src: imageUrl, alt: data.title && data.title + " \uD45C\uC9C0" }),
        createElement("span", { className: data.className + "_Shadow" }));
}; });

var hdBadge = (function (data) { return function (props) {
    var className = props.className;
    var Placeholder = data.setPlaceholder(false, !data.isComicHD);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    var size = (function () {
        if (props.thumbnailSize < 80) {
            return 'small';
        }
        if (props.thumbnailSize < 150) {
            return 'medium';
        }
        if (props.thumbnailSize <= 180) {
            return 'large';
        }
        return 'xlarge';
    })();
    return (createElement("div", { className: classNames(data.className, data.className + "-size-" + size, className) },
        createElement("div", { className: data.className + "_Label" }, "\uACE0\uD654\uC9C8")));
}; });

var setBooklet = (function (data) { return function (props) {
    var className = props.className;
    var Placeholder = data.setPlaceholder(false, data.memberBooksCount !== 0);
    if (Placeholder) {
        return createElement(Placeholder, { className: data.className });
    }
    var size = (function () {
        if (props.thumbnailSize < 80) {
            return 'small';
        }
        if (props.thumbnailSize < 150) {
            return 'medium';
        }
        if (props.thumbnailSize <= 180) {
            return 'large';
        }
        return 'xlarge';
    })();
    return (createElement("div", { className: classNames(data.className, data.className + "-size-" + size, className) },
        createElement("span", { className: data.className + "_Label" },
            createElement("span", { className: "museoSans" }, data.memberBooksCount),
            "\uAD8C \uC138\uD2B8")));
}; });

var DEFAULT_SIZE = 80;
var wrapper$1 = (function (data) { return function (props) {
    var className = props.className, dataset = props.dataset, _a = props.thumbnailSize, thumbnailSize = _a === void 0 ? DEFAULT_SIZE : _a, _b = props.link, link = _b === void 0 ? {} : _b;
    var thumbnailHeight = Math.floor(thumbnailSize * 1.618 - 10) + "px";
    var style = {
        width: thumbnailSize,
        height: thumbnailHeight,
        maxHeight: thumbnailHeight,
    };
    var linkClass = classNames(data.className + "_Link", (_c = {}, _c[data.className + "_Link-keepRatio"] = data.usePlaceholder, _c));
    var children = Children.map(props.children, function (child) {
        return isValidElement(child) && typeof child.type !== 'string'
            ? cloneElement(child, { thumbnailSize: thumbnailSize })
            : child;
    });
    return (createElement("div", { className: classNames(data.className, className), style: style }, link === 'unused'
        ? createElement("div", { className: linkClass }, children)
        : (createElement("a", __assign({ href: data.link, className: classNames(linkClass, link.className) }, handleDataset(link.dataset)), children))));
    var _c;
}; });

function withDisplayName$1(name, Component$$1) {
    Component$$1.displayName = "Thumbnail." + name;
    return Component$$1;
}
var default_1$1 = (function () {
    function default_1(state, setPlaceholder) {
        this.state = state;
        this.setPlaceholder = setPlaceholder;
        this.wrapper = withDisplayName$1('wrapper', wrapper$1(__assign({ className: 'RSGBookThumbnail', usePlaceholder: this.state.usePlaceholder }, this.state.thumbnailProps.wrapper)));
        this.coverImage = withDisplayName$1('coverImage', coverImage(__assign({ className: 'RSGBookThumbnail_CoverImage', setPlaceholder: this.setPlaceholder }, this.state.thumbnailProps.coverImage)));
        this.adultOnlyBadge = withDisplayName$1('adultOnlyBadge', adultOnlyBadge(__assign({ className: 'RSGBookThumbnail_AdultOnlyBadge', setPlaceholder: this.setPlaceholder }, this.state.thumbnailProps.adultOnlyBadge)));
        this.circleBadge = withDisplayName$1('circleBadge', circleBadge(__assign({ className: 'RSGBookThumbnail_CircleBadge', setPlaceholder: this.setPlaceholder }, this.state.thumbnailProps.circleBadge)));
        this.hdBadge = withDisplayName$1('hdBadge', hdBadge(__assign({ className: 'RSGBookThumbnail_HDBadge', setPlaceholder: this.setPlaceholder }, this.state.thumbnailProps.hdBadge)));
        this.setBooklet = withDisplayName$1('setBooklet', setBooklet(__assign({ className: 'RSGBookThumbnail_SetBooklet', setPlaceholder: this.setPlaceholder }, this.state.thumbnailProps.setBooklet)));
    }
    return default_1;
}());

var Book = (function (_super) {
    __extends(Book, _super);
    function Book(props) {
        var _this = _super.call(this, props) || this;
        _this.setPlaceholder = function (isRequired) {
            var requirements = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                requirements[_i - 1] = arguments[_i];
            }
            if (_this.state.usePlaceholder) {
                if (isRequired) {
                    return function (_a) {
                        var className = _a.className;
                        var computedClassName = classNames(className, className + "-placeholder", 'RSGBook_Placeholder');
                        return createElement("div", { className: computedClassName });
                    };
                }
                return function () { return null; };
            }
            else if (requirements.length && requirements.every(function (item) { return item; })) {
                if (isRequired) {
                    _this.setState({ usePlaceholder: true });
                }
                return function () { return null; };
            }
            return null;
        };
        var dto = camelize(_this.props.dto, { recursive: true });
        var _a = dto2props(dto), thumbnailProps = _a.thumbnailProps, metadataProps = _a.metadataProps;
        _this.state = {
            usePlaceholder: false,
            thumbnailProps: thumbnailProps,
            metadataProps: metadataProps,
        };
        return _this;
    }
    Book.prototype.render = function () {
        var _a = this.props, Element = _a.tagName, className = _a.className, style = _a.style, children = _a.children;
        if (typeof children !== 'function') {
            console.error('Children function is required. or use a BookPresets.');
            return null;
        }
        return (createElement(Element, { className: classNames('RSGBook', className), key: this.props.dto.id, style: style }, children({
            Thumbnail: new default_1$1(this.state, this.setPlaceholder),
            Metadata: new default_1(this.state, this.setPlaceholder),
        })));
    };
    Book.defaultProps = {
        tagName: 'div',
    };
    return Book;
}(Component));

export { Book };
//# sourceMappingURL=book.js.map



// WEBPACK FOOTER //
// /static/node_modules/@ridi/rsg/components/dist/book.js